import { render, staticRenderFns } from "./FormValidation.vue?vue&type=template&id=7b4ba136&"
import script from "./FormValidation.vue?vue&type=script&lang=js&"
export * from "./FormValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports